export default __webpack_public_path__ + "static/media/shape3.a0ed89ed.png";